import 'twin.macro'

import AppStep from 'components/UI/AppStep'
import { useAppSelector } from 'hooks'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { getCurrentStepNumberSelector } from 'redux/store/slices/statusSlice'
import { TwStyle } from 'twin.macro'
import { APP_STEPS } from 'utils/constants'

type AppStepsProps = {
  twStyle?: TwStyle
}

const AppSteps = ({ twStyle }: AppStepsProps) => {
  // Tools
  const { t } = useTranslation()

  // Selectors
  const { step: currentStep } = useAppSelector(getCurrentStepNumberSelector)

  return (
    <div tw='invisible md:visible space-y-5' css={twStyle}>
      {APP_STEPS.map(step => (
        <AppStep key={step.step} step={step.step} stepsCount={APP_STEPS.length} currentStep={currentStep}>
          {t(step.title)}
        </AppStep>
      ))}
    </div>
  )
}

export default memo(AppSteps)
